import getTitle from 'helpers/getTitle'
import {getId} from 'apis/model/base'
import Translate from 'modules/local/Translate'
import React from 'react'
import classNames from 'classnames'
import {NullAsDefault, renderIf} from 'views/Shared'
import copyToClipboard from "copy-to-clipboard";
import {message} from "antd";
import {IoCopyOutline} from "react-icons/io5";
import {RiSubscript} from "react-icons/ri";
import {TbListDetails} from "react-icons/tb";
import {getGroupColor} from "./renderCourseClassStudent";

// Layout mượn ĐÚNG ngôn ngữ thị giác của renderCourseSubjectCard bên dưới (icon nền màu theo tên,
// chip "bắt buộc"/"tín chỉ · tiết" thay vì ItemInformation dạng chữ trơn, mô tả trong ô nền nhạt) -
// trước đây 2 hàm vẽ 2 kiểu khác hẳn nhau dù cùng 1 loại dữ liệu, giờ đồng bộ - bản LIST này giữ dạng
// hàng ngang (không chuyển sang lưới thẻ) vì đang dùng cho danh sách chọn/bỏ chọn nhiều môn học, cuộn
// dọc dễ quét hơn lưới. renderActions(item) giữ NGUYÊN vị trí/API - mọi hành động (Switch bật/tắt,
// icon cấu hình PiFadersFill...) từ nơi gọi không đổi gì.
export const renderCourseSubject = ({ detail = true, renderActions = NullAsDefault, handleAction = (() => {})} = {}) => (item, index) => {
    const {subject, is_linked, number_of_credits, number_of_sessions, is_mandatory} = item ?? {}
    const {description, subject_idcode} = subject ?? {}
    const title = getTitle(subject)
    const accent = getGroupColor(title)
    const hasMeta = is_linked && (number_of_credits > 0 || number_of_sessions > 0)

    return (
        <Translate key={index}>
            {(t) => (
                <div style={{fontSize: 14}} className={classNames(
                    "p-4 flex gap-3 custom-item-render relative list-item transition-opacity duration-300",
                    !is_linked && "opacity-70 hover:opacity-100"
                )}>
                    <div
                        style={{width: 44, height: 44, background: `${accent}1a`}}
                        className="flex-shrink-0 flex flex-center rounded-xl">
                        <RiSubscript size={22} style={{color: accent}}/>
                    </div>
                    <div className="flex flex-col flex-1 min-w-0 gap-1.5">
                        <div className="flex items-start gap-3">
                            <div className="flex flex-col flex-1 min-w-0 gap-0.5">
                                <span className="font-bold text-base text-gray-800 leading-snug tracking-wide">
                                    {title}
                                </span>
                                {renderIf(
                                    subject_idcode,
                                    <span
                                        onClick={() => {
                                            copyToClipboard(subject_idcode)
                                            message.success(t('copied'))
                                        }}
                                        className="w-fit flex items-center gap-1 font-mono text-xs text-secondary hover:text-secondary-600 cursor-pointer tracking-wider">
                                        {subject_idcode}
                                        <IoCopyOutline size={11}/>
                                    </span>
                                )}
                            </div>
                            <div className="flex-shrink-0">
                                {renderActions(item)}
                            </div>
                        </div>

                        {renderIf(
                            is_mandatory === 1 || hasMeta,
                            <div className="flex flex-wrap items-center gap-1.5">
                                {renderIf(
                                    is_mandatory === 1,
                                    <span className="px-2 py-0.5 rounded-full bg-primary-50 text-primary-500 font-semibold text-2xs tracking-wide whitespace-no-wrap">
                                        {`* ${t('is mandatory subject')}`}
                                    </span>
                                )}
                                {renderIf(
                                    hasMeta,
                                    <span className="px-2 py-0.5 rounded-full background-100 text-color-300 font-medium text-2xs tracking-wide whitespace-no-wrap">
                                        {[
                                            number_of_credits > 0 && `${number_of_credits} ${t('credits')}`,
                                            number_of_sessions > 0 && `${number_of_sessions} ${t('sessions')}`,
                                        ].filter(Boolean).join(' • ')}
                                    </span>
                                )}
                            </div>
                        )}

                        {renderIf(
                            description,
                            <div className="px-3 py-2 rounded-lg background-100 text-xs text-color-300 tracking-wide leading-snug max-lines-3">
                                {description}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </Translate>
    )
}

// Biến thể "thẻ" cho danh sách môn học trong lớp (CourseClassSubjectList) - icon nền màu theo
// tên + tiêu đề xanh + mã có nút copy, chip "bắt buộc" / "tín chỉ · tiết", mô tả trong ô nền
// nhạt, chân thẻ hiện nhóm môn. Actions (Switch bật/tắt) do call site truyền vào, đặt góc phải.
export const renderCourseSubjectCard = ({renderActions = NullAsDefault} = {}) => (item, index) => {
    const {subject, is_linked, number_of_credits, number_of_sessions, is_mandatory, group_name} = item ?? {}
    const {description, subject_idcode} = subject ?? {}
    const title = getTitle(subject)
    const accent = getGroupColor(title)
    const hasMeta = is_linked && (number_of_credits > 0 || number_of_sessions > 0)

    return (
        <Translate key={index}>
            {(t) => (
                <div
                    style={{fontSize: 14}}
                    className={classNames(
                        "h-full p-4 flex flex-col gap-3 background border rounded-2xl transition-all duration-300 custom-item-render",
                        is_linked ? "border-secondary-300 hover:shadow-md" : "border-color-100 opacity-70 hover:opacity-100"
                    )}>
                    <div className="flex items-start gap-3">
                        <div
                            style={{width: 44, height: 44, background: `${accent}1a`}}
                            className="flex-shrink-0 flex flex-center rounded-xl">
                            <RiSubscript size={22} style={{color: accent}}/>
                        </div>
                        <div className="flex flex-col flex-1 min-w-0 gap-0.5">
                            <span className="font-bold text-base text-gray-700 leading-snug tracking-wide">
                                {title}
                            </span>
                            {renderIf(
                                subject_idcode,
                                <span
                                    onClick={() => {
                                        copyToClipboard(subject_idcode)
                                        message.success(t('copied'))
                                    }}
                                    className="w-fit flex items-center gap-1 font-mono text-xs text-secondary hover:text-secondary-600 cursor-pointer tracking-wider">
                                    {subject_idcode}
                                    <IoCopyOutline size={11}/>
                                </span>
                            )}
                        </div>
                        <div className="flex-shrink-0">
                            {renderActions(item)}
                        </div>
                    </div>

                    {renderIf(
                        is_mandatory === 1 || hasMeta,
                        <div className="flex flex-wrap items-center gap-1.5">
                            {renderIf(
                                is_mandatory === 1,
                                <span className="px-2 py-0.5 rounded-full bg-primary-50 text-primary-500 font-semibold text-2xs tracking-wide whitespace-no-wrap">
                                    {`* ${t('is mandatory subject')}`}
                                </span>
                            )}
                            {renderIf(
                                hasMeta,
                                <span className="px-2 py-0.5 rounded-full background-100 text-color-300 font-medium text-2xs tracking-wide whitespace-no-wrap">
                                    {[
                                        number_of_credits > 0 && `${number_of_credits} ${t('credits')}`,
                                        number_of_sessions > 0 && `${number_of_sessions} ${t('sessions')}`,
                                    ].filter(Boolean).join(' • ')}
                                </span>
                            )}
                        </div>
                    )}

                    {renderIf(
                        description,
                        <div className="px-3 py-2 rounded-lg background-100 text-xs text-color-300 tracking-wide leading-snug max-lines-3">
                            {description}
                        </div>
                    )}

                    {renderIf(
                        group_name,
                        <div className="mt-auto pt-2 border-t border-color-50 flex items-center gap-1.5 text-2xs text-color-400 tracking-wide">
                            <TbListDetails size={12}/>
                            {group_name}
                        </div>
                    )}
                </div>
            )}
        </Translate>
    )
}

// Biến thể "chip" - gọn cho tab Cấu hình Lớp học (CourseClassSubjectChips): chọn/bỏ chọn nhanh
// nhiều môn của Khóa cho Lớp bằng cách bấm chip, tô đậm khi is_linked=true. Khác 2 biến thể trên
// (đều cần renderActions/Switch riêng + confirm trước khi đổi), chip đổi trạng thái NGAY khi bấm
// (đúng cảm giác "chọn nhiều lựa chọn" của chip-select, không phải thao tác cần xác nhận) - onToggle
// do call site truyền vào tự quyết định link/unlink.
export const renderCourseSubjectChip = ({onToggle = (() => {}), isPending = (() => false)} = {}) => (item, index) => {
    const {subject, is_linked, is_mandatory} = item ?? {}
    const title = getTitle(subject)
    const pending = isPending(item)

    return (
        <button
            key={index}
            type="button"
            disabled={pending}
            onClick={() => onToggle(item)}
            style={{minHeight: 32}}
            className={classNames(
                'px-3 py-1 flex items-center gap-1 rounded-lg text-xs font-semibold border leading-tight transition-all duration-300',
                pending && 'opacity-50 cursor-wait',
                is_linked
                    ? 'bg-primary-600 border-primary-600 text-white'
                    : 'bg-white border-color-100 text-color-300 hover:border-primary-300 hover:text-primary-600'
            )}>
            {title}
            {renderIf(
                is_mandatory === 1,
                <span className={is_linked ? 'text-white/80' : 'text-primary-400'}>*</span>
            )}
        </button>
    )
}

